import React, { Component, PropTypes } from 'react';
import Raphael from 'raphael';
window.Raphael = Raphael; // required by dmak to be present globally
import 'dmak'; // exposes itself on window.Dmak

class ReactDmak extends Component {
  constructor(props) {
    super(props);
    this.id = `dmak-${Math.random()}`;
    this.element = null;
    this.dmak = null;

    this.setDrawDivRef = element => {
      this.element = element;
    };

    this.draw = () => {
      if (this.element !== null) {
        if (this.dmak !== null) {
          this.dmak.pause();
        }
        this.element.innerHTML = '';
        this.dmak = new window.Dmak(this.props.character, {
          // dmak has a bug where specifying an element does not work so we just use a "unique" id
          element: this.element.id,
          height: 320,
          width: 320,
          step: 0.02,
          // these were downloaded from https://kanjivg.tagaini.net/ and
          // manually uploaded to the S3 assets.iknow.jp bucket
          //
          // for local dev unzip the kanji folder into public/assets/
          uri: '/assets/kanji/',
          grid: {
            show: false,
          },
          stroke: {
            attr: {
              active: '#f09035',
              stroke: '#ffffff',
            },
          },
        });
      }
    };
  }

  componentDidMount() {
    this.draw();
  }

  componentDidUpdate() {
    this.draw();
  }

  componentWillUnmount() {
    if (this.dmak !== null) {
      this.dmak.pause();
      this.dmak = null;
    }
  }

  render() {
    return <div id={this.id} ref={this.setDrawDivRef} onClick={this.draw} />;
  }
}

ReactDmak.propTypes = {
  character: PropTypes.string.isRequired,
};

export default ReactDmak;
